import { Link, useLocation } from "react-router-dom";
import { tokens } from "../../../styles/theme";
import Header from "../../../components/Header";
import React, { useEffect, useState } from "react";
import { Box, useTheme, Button } from "@mui/material";
import * as sweetalert from "sweetalert";
import axios from "axios";
import ConfirmDialog from "../global/ConfirmDialog";
import {
  GridRowModes,
  DataGridPro,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  GridToolbarExport,
} from "@mui/x-data-grid-pro";
import PropTypes from "prop-types";
import { useNavigate, useParams } from "react-router-dom";
import ContainerUpdates from "./ContainerUpdates";
import packageJson from "../../../../package.json";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
function EditToolbar(props) {
  return (
    <>
      <GridToolbarContainer>
        <Box className="div-btn-header">
          <Button
            component={Link}
            variant="contained"
            className="btn-submit"
            color="secondary"
            to="/getfund"
          >
            رجوع
          </Button>
        </Box>
      </GridToolbarContainer>

      <GridToolbarContainer>
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector />
        <GridToolbarExport />
      </GridToolbarContainer>
    </>
  );
}
EditToolbar.propTypes = {
  setRowModesModel: PropTypes.func.isRequired,
};

const FundValue = () => {
  const { id } = useParams();
  const location = useLocation();

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [values, setValues] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [rowModesModel, setRowModesModel] = React.useState({});
  const [rows, setRows] = React.useState();
  const [fundname, setfundName] = React.useState();

  const [fundtype, setfundType] = React.useState();
  const [fundtype1, setfundType1] = React.useState();
  const [fundtype2, setfundType2] = React.useState();
  const [fundtype3, setfundType3] = React.useState();
  const [fundtype4, setfundType4] = React.useState();
  const [fundtypeadmin, setfundTypeAdmin] = React.useState();
  const [VoucherId, setVoucherId] = React.useState();
  const [fundcompany, setfundCompany] = React.useState([]);
  const [pricegeneral, setPriceGeneral] = React.useState([]);
  const [priceprivate, setPricePrivate] = React.useState([]);

  useEffect(() => {
    setIsLoading(true);
    axios
      .get(
        `${BaseUrl}/api/getValueByID/${id}`,
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        setUsers(res.data.data.fund_name);

        setValues(res.data.data.fundvalues.map((e) => e));
        setValues(res.data.data.fundvalues.map((e) => e));
        setIsLoading(false);
        setfundType(
          res.data.data.fundvalues.map((n) => ({
            ...id,
            ["p"]: { id: n.id, fund_value: n.fund_value },
          }))
        );

        setfundType1(
          res.data.data.fundvalues.map((n) => ({
            ...id,
            ["p"]: {
              id: n.id,
              fund_price_for_general_distributor:
                n.fund_price_for_general_distributor,
            },
          }))
        );
        setfundType2(
          res.data.data.fundvalues.map((n) => ({
            ...id,
            ["p"]: { id: n.id, fund_price_for_client: n.fund_price_for_client },
          }))
        );
        setfundType3(
          res.data.data.fundvalues.map((n) => ({
            ...id,
            ["p"]: {
              id: n.id,
              fund_price_for_special_distributor:
                n.fund_price_for_special_distributor,
            },
          }))
        );
        setfundType4(
          res.data.data.fundvalues.map((n) => ({
            ...id,
            ["p"]: {
              id: n.id,
              fund_profit: n.fund_profit,
            },
          }))
        );
        setfundTypeAdmin(
          res.data.data.fundvalues.map((n) => ({
            ...id,
            ["p"]: {
              id: n.id,
              fund_price_for_admin: n.fund_price_for_admin,
            },
          }))
        );
        setVoucherId(
          res.data.data.fundvalues.map((n) => ({
            ...id,
            ["p"]: {
              id: n.id,
              voucher_id: n.voucher_id,
            },
          }))
        );
      })
      .catch((err) => {
        setUsers([]);
        setIsLoading(false);
      });

    return () => {};
  }, []);

  const handleRowEditStart = (params, event) => {
    event.defaultMuiPrevented = true;
  };

  const handleRowEditStop = (params, event) => {
    event.defaultMuiPrevented = true;
  };
  const handleDeleteClick = (id) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
    axios
      .get(
        `${BaseUrl}/api/deleteValueFromFund/${id}`,
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        if (res.status === 200) {
          sweetalert("تمت العملية بنجاح", {
            className: "alert-div",
            button: {
              text: "تم",
            },
          });
          setValues(values.filter((row) => row.id !== id));
        } else {
          sweetalert("هذا المستخدم غير موجود", {
            className: "alert-div",
            button: {
              text: "تم",
            },
          });
        }
      })
      .catch((err) => {});
  };

  const processRowUpdate = (newRow) => {
    const updatedRow = { ...newRow, isNew: false };
    setRows(rows.map((row) => (row.id === newRow.id ? updatedRow : row)));
    return updatedRow;
  };

  const columns = [
    {
      field: { users },
      headerName: " اسم الرصيد",
      headerAlign: "center",
      align: "center",
      flex: 1,
      cellClassName: "name-column--cell",
      editable: false,
      valueGetter: (params) => {
        return params.field.users;
      },
    },
    {
      field: "fund_value",
      headerName: "قيمة الرصيد",
      headerAlign: "center",
      align: "center",
      flex: 1,

      cellClassName: "name-column--cell",
      editable: false,
      valueGetter: (params) => {
        return params.row.fund_value;
      },
    },
    {
      field: "fund_price_for_admin",
      headerName: "سعر للادمن",
      headerAlign: "center",
      align: "center",
      flex: 1,

      cellClassName: "name-column--cell",
      editable: false,
      valueGetter: (params) => {
        return params.row.fund_price_for_admin;
      },
    },
    {
      field: "fund_price_for_client",
      headerName: "سعر الزبون",
      headerAlign: "center",
      align: "center",
      flex: 1,
      cellClassName: "name-column--cell",
      editable: false,
      valueGetter: (params) => {
        return params.row.fund_price_for_client;
      },
    },
    {
      field: "fund_price_for_general_distributor",
      headerName: "سعر الموزع العام",
      headerAlign: "center",
      align: "center",
      flex: 1,
      cellClassName: "name-column--cell",
      editable: false,
      valueGetter: (params) => {
        return params.row.fund_price_for_general_distributor;
      },
    },
    {
      field: "fund_price_for_special_distributor",
      headerName: "سعر الموزع الخاص",
      headerAlign: "center",
      align: "center",
      flex: 1,
      cellClassName: "name-column--cell",
      editable: false,
      valueGetter: (params) => {
        return params.row.fund_price_for_special_distributor;
      },
    },
    {
      field: "actions",
      type: "actions",
      headerName: "اجراءات",
      headerAlign: "center",
      align: "center",
      flex: 1,
      cellClassName: "actions",
      renderCell: ({ id }) => {
        return (
          <Box className="editbtn">
            <Button
              variant="contained"
              color="primary"
              className="viewbtn"
              onClick={() => {
                setConfirmDialog({
                  isOpen: true,
                  title: "هل تريد حذف هذه السجل؟",
                  subTitle: "لايمكن التراجع عن هذه العملية",
                  onConfirm: () => {
                    handleDeleteClick(id);
                  },
                });
              }}
            >
              حذف
            </Button>
            <ContainerUpdates
              triggerText="تعديل"
              text1={"تعديل"}
              fundname={fundname}
              id={id}
              company={location.state.company}
              fundnamecompany={location.state.fundnamecompany}
              fundtype={fundtype}
              fundtype1={fundtype1}
              fundtype2={fundtype2}
              fundtype3={fundtype3}
              fundtype4={fundtype4}
              vocher_id={VoucherId}
              fundtypeadmin={fundtypeadmin}
              fundcompany={fundcompany}
              pricegeneral={pricegeneral}
              priceprivate={priceprivate}
            />
            <ConfirmDialog
              confirmDialog={confirmDialog}
              setConfirmDialog={setConfirmDialog}
            />
            ,
          </Box>
        );
      },
    },
  ];

  return (
    <Box m="2px 5px 0px 5px">
      <Header />

      <Box
        m="40px 0 0 0"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: colors.redAccent[1100],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.redAccent[1100],
            borderBottom: "none",
            fontSize: "10px !important",
          },
          "& .MuiDataGrid-cellContent": {
            fontSize: "10px !important",
            color: `${colors.grey[600]} !important`,
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.white[100],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.redAccent[1100],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
        }}
      >
        <DataGridPro
          rows={values}
          columns={columns}
          className="field-table"
          editMode="row"
          pageSize={10}
          pagination
          rowModesModel={rowModesModel}
          onRowModesModelChange={(newModel) => setRowModesModel(newModel)}
          onRowEditStart={handleRowEditStart}
          onRowEditStop={handleRowEditStop}
          processRowUpdate={processRowUpdate}
          components={{
            Toolbar: EditToolbar,
          }}
          localeText={{
          toolbarColumns: "الأعمدة",
          toolbarFilters: "الفلاتر",
          toolbarDensity: "التباعد",
          toolbarExport: "تصدير",
          filterPanelAddFilter:'إضافة فلتر',
          filterOperatorContains:'تحتوي',
          filterOperatorEquals:'تساوي',
          filterOperatorStartsWith:'تبدأ ب',
          filterOperatorEndsWith:'تنتهي  ب',
          filterOperatorIsAnyOf:'هو أي من',
          filterOperatorIsEmpty:'فارغ',
          filterOperatorIsNotEmpty:'غير فارغ',
          toolbarDensityCompact:'دمج',
          toolbarDensityStandard:'معيار',
          toolbarDensityComfortable:'مريح',
          toolbarExportCSV:'تصدير CSV',
          toolbarExportPrint:'طباعة',
          filterPanelInputLabel:'القيمة',
          filterPanelInputPlaceholder:"ادخل القيمة",
          filterPanelColumns:'الاعمدة',
          filterPanelOperators:'العمليات',
          columnsPanelTextFieldLabel:'بحث عن عمود',
          columnsPanelTextFieldPlaceholder:'عنوان العمود',

        }}
          componentsProps={{
            toolbar: { setRows, setRowModesModel },
          }}
          experimentalFeatures={{ newEditingApi: true }}
        />
      </Box>
    </Box>
  );
};

export default FundValue;
